import {
  BusinessHours,
  isWithinBusinessHours,
  TimeRange,
} from 'shared/utils/isWithinBusinessHours';

const weekdayHours: TimeRange = {
  start: [8, 0],
  end: [1, 0], // 1:00 AM next day
};

/*
 Business hours are defined in Eastern Time (ET) here to match the TPV's business hours.
*/
const TPVBusinessHours: BusinessHours = {
  0: {
    // Sunday
    start: [10, 0],
    end: [21, 0],
  },
  1: weekdayHours,
  2: weekdayHours,
  3: weekdayHours,
  4: weekdayHours,
  5: weekdayHours,
  6: {
    // Saturday
    start: [9, 0],
    end: [0, 0], // 12:00 AM next day
  },
};

export const isWithinTPVBusinessHours = () => isWithinBusinessHours(TPVBusinessHours);

export default isWithinTPVBusinessHours;
